import { Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { BackBtnIcon, DropdownCrossIcon } from "../../Icons";
import { GetThemeClass } from "../../../helper";

const Modal = ({
  isOpen,
  handleOnCloseModal,
  className,
  header,
  backButton,
  headerTitle,
  backButtonAction,
  loading,
  close = true,
  children,
}) => {
  const canClose = close && !loading ? handleOnCloseModal : () => {};
  return (
    <Transition.Root show={isOpen} as={Fragment}>
      <Dialog
        as="div"
        className={`app-modal relative z-50 ${GetThemeClass("light", "dark")}`}
        onClose={canClose}
      >
        {/* Backdrop */}
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div
            className={`fixed inset-0 backdrop ${
              loading ? "backdrop-loading" : "backdrop-default"
            }`}
          />
        </Transition.Child>

        {/* Modal panel */}
        <div className="fixed inset-0 z-50 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center sm:items-center px-1.5 sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className={`panel ${className}`}>
                {header && (
                  <Dialog.Title className="header sticky pt-2 top-0 z-10 mx-1">
                    <div className="flex justify-between items-center pb-2 px-6 max-[360px]:px-4">
                      <div className="flex justify-center items-center space-x-2">
                        {backButton && (
                          <div className="back-btn" onClick={backButtonAction}>
                            <BackBtnIcon />
                          </div>
                        )}
                        <h2 tabIndex={0} className="title">
                          {headerTitle}
                        </h2>
                      </div>
                      <div className="close-btn" onClick={handleOnCloseModal}>
                        <DropdownCrossIcon />
                      </div>
                    </div>
                  </Dialog.Title>
                )}
                {children}
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
};

export default Modal;
